








import Vue, { VueConstructor } from 'vue'
import { setIsFlats } from '@/application/EnharmonicManager'
import hasEnharmonics, { HasEnharmonicsMixinData } from '@/mixins/hasEnharmonics'
import hasBreakpoints, { HasBreakpointsMixinComputed } from '@/mixins/hasBreakpoints'

type Mixins = HasEnharmonicsMixinData & HasBreakpointsMixinComputed

export default (Vue as VueConstructor<Mixins>).extend({
  mixins: [hasEnharmonics, hasBreakpoints],
  computed: {
    textClasses() {
      return this.isMobile ? 'has-text-dark' : 'has-text-white'
    },
    switchType() {
      return this.isMobile ? 'is-dark' : 'is-white'
    }
  },
  methods: {
    updateIsFlats(isFlats: boolean) {
      setIsFlats(this.$route, this.$router, isFlats)
    }
  }
})
